import React, { FC } from 'react';
import { Route, Routes } from 'react-router';

import SetPasswordForm from './components/Auth/forms/SetPasswordForm';
import SessionPage from './components/Auth/SessionPage';
import RouteNotFound from './components/Routes/RouteNotFound';
import AddressShow from './pages/main/addresses/AddressShow';
import ConfirmationShow from './pages/main/auth/ConfirmationShow';
import EventShow from './pages/main/events/EventShow';
import PageShow from './pages/main/pages/PageShow';
import PostalCodeShow from './pages/main/postalCodes/PostalCodeShow';
import EventsPage from './pages/main/static/EventsPage';
import HomePage from './pages/main/static/HomePage';
import ImpactPage from './pages/main/static/ImpactPage';
import StartPage from './pages/main/static/StartPage';
import StreetShow from './pages/main/streets/StreetShow';

const MainRoutes: FC = () => (
  /* eslint-disable react/jsx-sort-props */
  <Routes>
    <Route path="/" element={<HomePage />} />
    <Route path="/static/start" element={<StartPage />} />
    <Route path="/static/events" element={<EventsPage />} />
    <Route path="/static/impact" element={<ImpactPage />} />
    <Route path="/addresses/:id" element={<AddressShow />} />
    <Route path="/events/:id" element={<EventShow />} />
    <Route path="/streets/:id" element={<StreetShow />} />
    <Route path="/pages/:id" element={<PageShow />} />
    <Route path="/postal_codes/:id" element={<PostalCodeShow />} />
    <Route path="/u/session/new" element={<SessionPage />} />
    <Route path="/u/registration/new" element={<SessionPage />} />
    <Route path="/u/password/new" element={<SessionPage />} />
    <Route path="/u/password/edit" element={<SetPasswordForm />} />
    <Route path="/u/confirmation" element={<ConfirmationShow />} />
    <Route path="*" element={<RouteNotFound />} key="linkedResources" />
  </Routes>
  /* eslint-enable react/jsx-sort-props */
);

export default MainRoutes;
